exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedorAnalisisFormularios .grafica_gestion .apexcharts-canvas{max-width:100%}.contenedorAnalisisFormularios .grafica_gestion .apexcharts-canvas svg{width:100%!important}.contenedorAnalisisFormularios .grafica_gestion .apexcharts-canvas svg foreignObject,.contenedorAnalisisFormularios .grafica_gestion .apexcharts-canvas svg g{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9d3855fa","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/AnalisisDeFormulario/AnalisisDeFormulario.vue
// module id = 1140
// module chunks = 0